import {useTheme} from '@emotion/react';
import Box from '@mui/material/Box';
import {getTagColor} from 'main/utility/helper/Utils';
import PropTypes from 'prop-types';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';
import {Fonts} from 'shared/constants/AppEnums';

const ProductGraph = ({productData}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        mt: 5,
        '& .graphText': {
          fontWeight: Fonts.MEDIUM,
          fontSize: 14,
        },
      }}
    >
      <ResponsiveContainer width='100%' height={300}>
        <BarChart
          barSize={8}
          data={productData}
          margin={{top: 0, right: 0, left: 0, bottom: 30}}
        >
          <CartesianGrid strokeDasharray='3 3' style={{paddingTop: 20}} />
          <XAxis hide />
          <YAxis hide />
          <Bar dataKey='quantity'>
            {productData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={getTagColor(theme, entry.color)}
                radius={[10, 10, 0, 0]}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default ProductGraph;

ProductGraph.defaultProps = {
  productData: [],
};

ProductGraph.propTypes = {
  productData: PropTypes.array,
};
